// extracted by mini-css-extract-plugin
export var active = "_3v-7";
export var container = "_3v-0";
export var evenWidth = "_3v-4";
export var large = "_3v-5";
export var outlet = "_3v-8";
export var slide = "_3v-2";
export var small = "_3v-6";
export var tab = "_3v-3";
export var tabs = "_3v-1";